import(/* webpackMode: "eager", webpackExports: ["Root","Item","Header","Trigger","Content"] */ "/opt/buildhome/repo/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/buttons/AppointmentButton.tsx");
